var map = {
	"./Approved.svg": 3792,
	"./AwaitingParts.svg": 3793,
	"./Closed.svg": 3794,
	"./Completed.svg": 3795,
	"./Excel.svg": 3796,
	"./Exportall_grey.svg": 3797,
	"./Exportall_grey_circle.svg": 3798,
	"./InProgress.svg": 3799,
	"./New.svg": 3800,
	"./View_Pic_Grey.svg": 3801,
	"./accident.svg": 3802,
	"./account.svg": 3803,
	"./addOrange.svg": 3804,
	"./addUser.svg": 3805,
	"./addVehicle.svg": 3806,
	"./address.svg": 3807,
	"./alert.svg": 3808,
	"./all_active.svg": 3809,
	"./all_active_es.svg": 3810,
	"./arrow-down.svg": 3811,
	"./arrow-up.svg": 3812,
	"./arrowRight.svg": 3813,
	"./awaiting_parts_grey.svg": 3814,
	"./awaiting_parts_orange.svg": 3815,
	"./back-btn.svg": 3816,
	"./back-button-grey.svg": 3817,
	"./backButton.svg": 3818,
	"./bills_of_landing_active.svg": 3819,
	"./bills_of_landing_active_es.svg": 3820,
	"./bobTail.svg": 3821,
	"./book-solid.svg": 3822,
	"./boxTruck.svg": 3823,
	"./calanderIcon.svg": 3824,
	"./cameraSelected.svg": 3825,
	"./camera_selected.svg": 3826,
	"./chat-icon.svg": 3827,
	"./circle-Exportall_grey.svg": 3828,
	"./circle-export.svg": 3829,
	"./circle-exportUser.svg": 3830,
	"./circle-import.svg": 3831,
	"./circle-importUser.svg": 3832,
	"./circle-viewall.svg": 3833,
	"./clearAll.svg": 3834,
	"./close-popup.svg": 3835,
	"./closeMap.svg": 3836,
	"./closed-Orange.svg": 3837,
	"./closed-grey.svg": 3838,
	"./clusterIcon.svg": 3839,
	"./communication_records_active.svg": 3840,
	"./communication_records_active_es.svg": 3841,
	"./company.svg": 3842,
	"./companyIcon.svg": 3843,
	"./complete-Orange.svg": 3844,
	"./complete-grey.svg": 3845,
	"./csa.svg": 3846,
	"./csaSnapshot.svg": 3847,
	"./dailyDocuments.svg": 3848,
	"./dashboard.svg": 3849,
	"./dashboardIcon.svg": 3850,
	"./date.svg": 3851,
	"./delete.svg": 3852,
	"./deleteCircle.svg": 3853,
	"./delivery_receipts_active.svg": 3854,
	"./delivery_receipts_active_es.svg": 3855,
	"./departments.svg": 3856,
	"./departmetEdit.svg": 3857,
	"./developer.svg": 3858,
	"./direction.svg": 3859,
	"./dispatch_records_active.svg": 3860,
	"./dispatch_records_active_es.svg": 3861,
	"./document.svg": 3862,
	"./documents.svg": 3863,
	"./dot.svg": 3864,
	"./dotAudit.svg": 3865,
	"./dotauditIcon.svg": 3866,
	"./downarrowIcon.svg": 3867,
	"./download.svg": 3868,
	"./downloadCenter.svg": 3869,
	"./downloadCenterMenu.svg": 3870,
	"./driver-behaviour.svg": 3871,
	"./driver.svg": 3872,
	"./dryVan.svg": 3873,
	"./dtc.svg": 3874,
	"./dualCam.svg": 3875,
	"./dump.svg": 3876,
	"./edit.svg": 3877,
	"./editLogIcon.svg": 3878,
	"./editSvg.svg": 3879,
	"./en.svg": 3880,
	"./es.svg": 3881,
	"./excelNew.svg": 3882,
	"./export-grey.svg": 3883,
	"./export.svg": 3884,
	"./exportUser.svg": 3885,
	"./feedback.svg": 3886,
	"./file-pdf-regular.svg": 3887,
	"./filter.svg": 3888,
	"./flatBed.svg": 3889,
	"./fleet.svg": 3890,
	"./fleetCompanies.svg": 3891,
	"./fleetdriverIcon.svg": 3892,
	"./fleetvehiclesIcon.svg": 3893,
	"./fletBed.svg": 3894,
	"./fuel.svg": 3895,
	"./full.svg": 3896,
	"./hamburger.svg": 3897,
	"./help-icon.svg": 3898,
	"./historyLogs.svg": 3899,
	"./icon-delete.svg": 3900,
	"./icon-export.svg": 3901,
	"./icon-menu-logs.svg": 3902,
	"./ifta.svg": 3903,
	"./import.svg": 3904,
	"./importUser.svg": 3905,
	"./in_progress_grey.svg": 3906,
	"./in_progress_orange.svg": 3907,
	"./infoTruck.svg": 3908,
	"./inspection-dvir.svg": 3909,
	"./inspection.svg": 3910,
	"./key.svg": 3911,
	"./leftArrow.svg": 3912,
	"./location.svg": 3913,
	"./locationMap.svg": 3914,
	"./log.svg": 3915,
	"./logEdit.svg": 3916,
	"./logHistory.svg": 3917,
	"./logoutIcon.svg": 3918,
	"./logs.svg": 3919,
	"./logsIcon.svg": 3920,
	"./mack.svg": 3921,
	"./mail.svg": 3922,
	"./main_camera.svg": 3923,
	"./mappinPopup.svg": 3924,
	"./menu_companies.svg": 3925,
	"./menu_dailyLog.svg": 3926,
	"./menu_reports.svg": 3927,
	"./menu_reseller.svg": 3928,
	"./menu_vehicle.svg": 3929,
	"./messageSender.svg": 3930,
	"./messaging.svg": 3931,
	"./new_login.svg": 3932,
	"./ninePin.svg": 3933,
	"./nonEdit.svg": 3934,
	"./notFull.svg": 3935,
	"./not_started_grey.svg": 3936,
	"./not_started_orange.svg": 3937,
	"./otherTrailer.svg": 3938,
	"./otherTruck.svg": 3939,
	"./other_documents_active.svg": 3940,
	"./other_documents_active_es.svg": 3941,
	"./overview.svg": 3942,
	"./page-first.svg": 3943,
	"./page-last.svg": 3944,
	"./page-next.svg": 3945,
	"./page-prev.svg": 3946,
	"./phone.svg": 3947,
	"./pickup.svg": 3948,
	"./pneumaticTrailer.svg": 3949,
	"./policy.svg": 3950,
	"./popupClose.svg": 3951,
	"./popupConfirm.svg": 3952,
	"./popupDelete.svg": 3953,
	"./privatePassenger.svg": 3954,
	"./qbdii.svg": 3955,
	"./receipts_active.svg": 3956,
	"./receipts_active_es.svg": 3957,
	"./reeferTrailer.svg": 3958,
	"./refreshCircle.svg": 3959,
	"./renewal.svg": 3960,
	"./repair.svg": 3961,
	"./reportIcon.svg": 3962,
	"./reports.svg": 3963,
	"./save-regular.svg": 3964,
	"./scoreCard.svg": 3965,
	"./searchGrey.svg": 3966,
	"./selectedConnection.svg": 3967,
	"./share.svg": 3968,
	"./sixPin.svg": 3969,
	"./sort.svg": 3970,
	"./speedometer.svg": 3971,
	"./spotlightGreen.svg": 3972,
	"./spotlightGrey.svg": 3973,
	"./spotlightRed.svg": 3974,
	"./straightTruck.svg": 3975,
	"./supportIcon.svg": 3976,
	"./switch.svg": 3977,
	"./tankerTrailer.svg": 3978,
	"./tick.svg": 3979,
	"./time.svg": 3980,
	"./timePicker.svg": 3981,
	"./toggle-off.svg": 3982,
	"./toggle-on.svg": 3983,
	"./tools.svg": 3984,
	"./tractorDayCab.svg": 3985,
	"./tractorSleeper.svg": 3986,
	"./undelete.svg": 3987,
	"./unsaved.svg": 3988,
	"./update.svg": 3989,
	"./upload.svg": 3990,
	"./usdot.svg": 3991,
	"./user.svg": 3992,
	"./userprofileIcon.svg": 3993,
	"./users.svg": 3994,
	"./vacuumTrailer.svg": 3995,
	"./vacuumTruck.svg": 3996,
	"./van.svg": 3997,
	"./vehicle-behaviour.svg": 3998,
	"./vehicle.svg": 3999,
	"./vehicleIcon.svg": 4000,
	"./viewArrow.svg": 4001,
	"./viewDocument.svg": 4002,
	"./viewReports.svg": 4003,
	"./viewStatus.svg": 4004,
	"./viewallMap.svg": 4005,
	"./violation.svg": 4006,
	"./volvo.svg": 4007,
	"./weigh_tickets_active.svg": 4008,
	"./weigh_tickets_active_es.svg": 4009,
	"./whitecheck_new.svg": 4010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3791;